import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import _, { cloneDeep } from "lodash";

import { BackToPatientProfile } from "../BackToPatientProfile";
import { MemberHeader } from "../../../../../component-library/MemberHeader";
import { admin_cse } from "../../../../../config/roles";
import { calculateAge } from "../../../../../utils/momentUtils";
import { formatMobileNumber } from "../../../../../utils/filters";
import { isAuthorized } from "../../../../../redux/actions/auth";
import { usePatient, usePatientDiagnosis } from "../../../../../utils/hooks/usePatient";

import { AdvancedCareActivityForm } from "./AdvancedCareActivityForm";
import { ADVANCED_CARE_ACTIVITY_INITIAL_VALUES } from "./constants";

import "./styles.scss";

export const AdvancedCareActivityNewForm = () => {
  const { patientId } = useParams();
  const history = useHistory();
  const patient = usePatient(patientId, history.location.state?.patientDetails);
  const diagnosis = usePatientDiagnosis(patientId, history.location.state?.patientDiagnosis);
  const primaryDiagnosis = _.get(diagnosis, "ICD_10_axis_1_diagnosis", [])
    .map((icd_10) => icd_10["value"])
    .join(", ");

  const secondaryDiagnosis = _.get(diagnosis, "ICD_10_axis_2_diagnosis", [])
    .map((icd_10) => icd_10["value"])
    .join(", ");

  const current_user = useSelector((state) => state.auth.profile);
  const [initialValues, setInitialValues] = useState();

  // setup form state
  useEffect(() => {
    if (!patient || !current_user) {
      return;
    }

    const noteStateToClone = ADVANCED_CARE_ACTIVITY_INITIAL_VALUES;
    const localInitialValues = cloneDeep(noteStateToClone);

    localInitialValues.patient_id = patient.username;
    localInitialValues.patient_first_name = patient.first_name;
    localInitialValues.patient_last_name = patient.last_name;

    if (isAuthorized(admin_cse)) {
      localInitialValues.admin_name = current_user.name;
      localInitialValues.admin_id = current_user.username;
    } else {
      localInitialValues.provider_id = current_user.username;
      localInitialValues.provider_name = current_user.name;
      localInitialValues.provider_type = current_user.provider_type;
      localInitialValues.provider_cp_credentials = current_user.cp_credentials;
    }

    setInitialValues(localInitialValues);
  }, [patient, current_user]);

  return (
    <>
      <BackToPatientProfile patientId={patientId} />

      <div className="tw:flex tw:w-full tw:flex-col tw:gap-5">
        {patient && current_user && diagnosis && (
          <MemberHeader
            age={calculateAge(_.get(patient, "dob", ""))}
            dayOfCare={_.get(patient, "number_of_days_in_care", "")}
            dob={_.get(patient, "dob")}
            memberName={`${_.get(patient, "first_name", "")} ${_.get(patient, "last_name", "")}`}
            phoneNumber={formatMobileNumber(_.get(patient, "mobile"))}
            primaryDiagnosis={primaryDiagnosis === "" ? "None" : primaryDiagnosis}
            secondaryDiagnosis={secondaryDiagnosis === "" ? "None" : secondaryDiagnosis}
          />
        )}

        <AdvancedCareActivityForm
          isEditing={true}
          nameToSign={current_user?.name}
          noteState={initialValues}
          patientId={patient?.username}
        />
      </div>
    </>
  );
};
